import { useCallback, useEffect, useState } from "react";

export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  window.matchMedia("(display-mode: fullscreen)").matches ||
  window.navigator.standalone === true;

export const platform = () => {
  const ua = window.navigator.userAgent;
  if (/iphone|ipad|ipod/i.test(ua) && !window.MSStream) return "ios";
  if (/android/i.test(ua)) return "android";
  return "desktop";
};

export function useInstallPrompt() {
  const [available, setAvailable] = useState(Boolean(window.__bip));
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const onReady = () => setAvailable(true);
    const onInstalled = () => { setAvailable(false); setInstalled(true); };
    window.addEventListener("bip-ready", onReady);
    window.addEventListener("bip-installed", onInstalled);
    return () => {
      window.removeEventListener("bip-ready", onReady);
      window.removeEventListener("bip-installed", onInstalled);
    };
  }, []);

  const install = useCallback(async () => {
    const evt = window.__bip;
    if (!evt) return "unavailable";
    evt.prompt();
    const { outcome } = await evt.userChoice;
    window.__bip = null;
    setAvailable(false);
    return outcome;
  }, []);

  return { available, installed, install, platform: platform() };
}
